import gql from 'graphql-tag'

export const GET_TAXONOMY = gql`
  query GetTaxonomy($key: String, $usedBy: [String]) {
    getTaxonomy(key: $key, usedBy: $usedBy) {
      key
      name
      description
      dateCreated
      dateUpdated
      usedBy
      treeData {
        key: id
        refId
        name
        parent
      }
    }
  }
`
